export enum ShipmentStatus {
  /**
   * One or more ship orders have been grouped, and a route has been generated for those ship orders
   */
  PLANNING = 'PLANNING',

  /**
   * A carrier has been assigned
   */
  CARRIER_ASSIGNED = 'CARRIER_ASSIGNED',

  /**
   * We have requested services from the assigned carrier
   */
  TENDERED = 'TENDERED',

  /**
   * The carrier has rejected the tender request
   */
  TENDER_REJECTED = 'TENDER_REJECTED',

  /**
   * The carrier has accepted the tender request
   */
  BOOKED = 'BOOKED',

  /**
   * One or more ship orders have been picked up
   */
  IN_TRANSIT = 'IN_TRANSIT',

  /**
   * All ship orders have been delivered to their final location
   */
  DELIVERED = 'DELIVERED',

  /**
   * All related invoices have been paid
   */
  COMPLETE = 'COMPLETE',

  /**
   * The shipment was canceled
   */
  CANCELED = 'CANCELED',
}

export const EDITABLE_STATUSES = [
  ShipmentStatus.BOOKED,
  ShipmentStatus.IN_TRANSIT,
  ShipmentStatus.DELIVERED,
];

export const isEditableShipmentStatus = (
  status: ShipmentStatus | undefined,
): boolean => {
  return !!status && EDITABLE_STATUSES.includes(status);
};
